import React, { FC, PropsWithChildren } from 'react';

import { CrossIcon } from '../../../../common';

import './ProjectFilterClear.scoped.scss';

interface Props {
  action: () => void;
}

const ProjectFilterClear: FC<PropsWithChildren<Props>> = ({ action, children }) => {
  return (
    <div className="project-filter-clear">
      <div className="project-filter-clear__text">{children}</div>
      <div onClick={() => action()} className="project-filter-clear__button">
        <CrossIcon preset="circle" size={16} title="Сбросить фильтр" />
      </div>
    </div>
  );
};

export default ProjectFilterClear;
